// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var DebitorAccountGeneratorController = function ($scope, $http, DebitorAccountGenerator) {
    $scope.generateForExisting = function () {
        $scope.notifySuccess();
        $scope.settings.$update(function () {
            $http({
                method: "POST",
                url: "/api/v1/debitoraccountgenerator/generateForExisting",
                params: null,
                data: {},
                headers: {},
                cache: false
            }).then(function (response) {
                alert("Added Debitor Ids to {n} customers".replace("{n}", response.data.NumberOfGeneratedDebitorAccounts));
            });
        });
    };

    $scope.save = function () {
        $scope.settings.$update({}, function () {
            $scope.notifySuccess();
        });
    };

    $scope.settings = DebitorAccountGenerator.get();
};
DebitorAccountGeneratorController.$inject = ['$scope', '$http', 'DebitorAccountGenerator'];
